import styled from '@emotion/styled';

export type TagDetailFieldProps = {
  label: string;
  value: string | number | null | undefined;
};

export const TagDetailField = ({ label, value }: TagDetailFieldProps) => (
  <Root>
    <Label>{label}</Label>
    <Value>{value ?? 'N/A'}</Value>
  </Root>
);

TagDetailField.displayName = 'TagDetails.Field';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-family: var(--font-bold);
  color: var(--gray-d);
  font-size: 14px;
`;

const Value = styled.div`
  font-size: 14px;
  color: var(--black);
  line-height: 1.4;
  word-break: break-word;
  min-height: 20px;
  display: flex;
  align-items: center;
`;
